<template>
  <div id="bar-value" class="vx-row">
    <div :class="getClassName()">
      <div class="card">
        <small> {{ $t("totalOil") }}</small>
        <div>
          <p class="h7">
            <vs-icon icon="invert_colors"></vs-icon> {{ data[0] }}
            {{ $t("Liter") }}
          </p>
        </div>
      </div>
    </div>
    <div :class="getClassName()">
      <vx-tooltip text="ยอดรวมน้ำมัน * ราคาน้ำมัน" position="top">
        <div class="card">
          <small> {{ $t("TotalIsExciseRate") }}</small>
          <div>
            <p class="h7">
              <vs-icon icon="invert_colors"></vs-icon> {{ data[1] }}
              {{ $t("Baht") }}
            </p>
          </div>
        </div>
      </vx-tooltip>
    </div>
    <div v-if="enableTax" :class="getClassName()">
      <div class="card">
        <small> {{ $t("TotalIsExciseExemption") }}</small>
        <div>
          <p class="h7">
            <vs-icon icon="invert_colors"></vs-icon> {{ data[2] }}
            {{ $t("Baht") }}
          </p>
        </div>
      </div>
    </div>
    <div :class="getClassName()">
      <div class="card">
        <small> {{ $t("PercentOfLost") }}</small>
        <div>
          <p class="h7">
            <vs-icon icon="invert_colors"></vs-icon> {{ data[3] }}
            {{ $t("Baht") }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { formatNumber } from "@/utils/index";

export default {
  name: "barValue",
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    enableTax: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      formatNumber,
      maxWidth: 250,
      base: 0,
    };
  },
  methods: {
    getClassName() {
      const cols = this.enableTax ? 4 : 3
      return `vx-col w-full sm:w-1/${cols} lg:w-1/${cols} xl:w-1/${cols}`;
    },
  },
};
</script>
<style scoped>
.card {
  max-width: 300px;
  min-width: 137px;
  background-color: #f7f7f7;
  border-radius: 5px;
  padding: 2px;
}
</style>
